<template>
    <div class="ion-page">
        <ion-header>
            <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons slot="start">
            <ion-back-button></ion-back-button>
            </ion-buttons>
            <!-- <ion-buttons slot="start">
                <ion-menu-button></ion-menu-button>
            </ion-buttons> -->
            <ion-title>Corporate Details</ion-title>
            <ion-buttons slot="end" v-if="viewmode">
            <ion-button @click="editCorporateDetails">
                EDIT
            </ion-button>
            </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
        <CorporateDetails  v-if="!viewmode"/>
        <CorporateView  v-if="viewmode"/>
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
// @ is an alias to /src
import CorporateDetails from "@/components/corporate/corporateDetails.vue";
import CorporateView from "@/components/corporate/corporateView.vue";
import { IonBackButton, IonButton, IonButtons, IonContent, IonHeader, IonTitle, IonToolbar } from "@ionic/vue";

export default defineComponent ({
    name: 'corporateManage',
    components: {
        CorporateDetails, CorporateView, IonHeader, IonToolbar, IonBackButton, IonButtons, IonButton, IonTitle, IonContent
    },
    data() {
        return {
            rightToUpdate: false,
            viewmode: false,
            corporateId: "New"
        }
    },
    async mounted() {
        if (this.$route.params.corporateId) {
        if (this.$route.query.mode) {
            this.viewmode = false;
            this.corporateId = "Edit";
        } else {
            this.viewmode = true;
            this.corporateId = "Detail";
        }
        }
    },
    methods: {
        editCorporateDetails() {
        this.viewmode = false;
        this.chargerId = "Edit";
        }
    }
})
</script>